// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3Efl1","fileBtn":"File_fileBtn__3D-G4","closeBtn":"File_closeBtn__1hZab","fileSelected":"File_fileSelected__2Mw_F","disabled":"File_disabled__2OSIV"};